<template>
  <div class="container-fluid border-end">
    <form @submit.prevent="submitForm">
      <div class="mb-3">
        <label for="transferBatch" class="form-label">Transfer Batch No.</label>
        <input
          type="text"
          class="form-control"
          id="transferBatch"
          v-model="transferBatch"
        />
      </div>
      <div class="mb-3">
        <label for="transferring-agency" class="form-label"
          >Transferring Agency</label
        >
        <select
          v-model="transferringAgency"
          id="transferring-agency"
          class="form-select"
          style="width: 100%"
        >
          <option selected value="">Select...</option>
          <option v-for="data in AgencyList" :value="data['AgencyName']">
            {{ data["AgencyDisplayName"] }}
          </option>
        </select>
      </div>
      <div class="d-block">
        <button
          class="btn btn-clear btn-outline-secondary"
          type="button"
          @click="clearAll"
        >
          Clear All
        </button>
        <button
          class="btn btn-search btn-primary"
          type="button"
          @click="submitForm"
        >
          Search
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import AgencyList from "../../../public/AgencyList.json";
import { ref } from "vue";

const emit = defineEmits(["listenTransferNumber"]);
const transferringAgency = ref("");
const transferBatch = ref("");

const submitForm = () => {
  let searchField = {
    transferBatch: transferBatch.value,
    transferringAgency: transferringAgency.value,
  };
  emit("listenTransferNumber", searchField);
};

const clearAll = () => {
  transferBatch.value = "";
  transferringAgency.value = "";
  let searchField = {
    transferBatch: transferBatch.value,
    transferringAgency: transferringAgency.value,
  };
  emit("listenTransferNumber", searchField);
};
</script>

<style scoped>
.container-fluid {
  position: fixed;
  padding-top: 20px;
  width: 24%;
  height: 100%;
  overflow: auto;
}
.btn-clear {
  margin-top: 1rem;
  margin-right: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
.btn-search {
  margin-top: 1rem;
  margin-left: 1%;
  width: 49%;
  margin-bottom: 5rem;
}
</style>
